<nav
    class="flex items-center gap-[var(--ssds-layout-spacing-xs)] lg:gap-[var(--ssds-layout-spacing-lg)] font-normal flex-col lg:flex-row text-[var(--ssds-text-brand-regular)]"
>
    <ng-container *ngFor="let link of links">
        <a
            [routerLink]="link.path"
            (click)="onLinkClick(link)"
            class="h-[36px] lg:h-[var(--ssds-component-sizing-120)] flex items-center border-t-[3px] border-b-[3px] border-transparent"
            [ngClass]="{
                'lg:border-b-[var(--ssds-border-brand-regular)]': link.path === activeLink
            }"
        >
            {{ link.label }}
        </a>
    </ng-container>
</nav>
